import * as React from 'react';
function PlaceholderRegistrationDocumentRear(props: React.SVGProps<SVGSVGElement>) {
	const { style, ...svgProps } = props;

	return (
		<svg
			width="328"
			height="200"
			viewBox="0 0 328 200"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...svgProps}
			style={{
				fill: 'none',
				backgroundColor: 'transparent',
				borderRadius: 0,
				opacity: 1,
				...style,
			}}
		>
			<g clipPath="url(#clip0_7482_32142)">
				<path d="M328 0H0V200H328V0Z" fill="#F3F4F6" />
				<g filter="url(#filter0_d_7482_32142)">
					<path d="M235 11H94V189H235V11Z" fill="white" />
					<path d="M234.5 11.5V188.5H94.5V11.5H234.5Z" stroke="#C8C8C8" />
				</g>
				<path d="M235 11H94V25H235V11Z" fill="#888B8D" />
				<path opacity={0.1} d="M159.5 107.5V149.5H102.5V107.5H159.5Z" stroke="black" />
				<path opacity={0.1} d="M159.5 156.5V182.5H102.5V156.5H159.5Z" stroke="black" />
				<path opacity={0.2} d="M160 44H140V64H160V44Z" fill="#7F7F7F" />
				<g clipPath="url(#clip1_7482_32142)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M151.107 55.9987C150.821 55.9987 150.592 56.2271 150.592 56.5135V58H148.891C148.604 58 148.375 58.2284 148.375 58.5148V60.5867C148.375 60.8732 148.604 61.1016 148.891 61.1016C149.177 61.1016 149.406 60.8732 149.406 60.5867V59.0296H151.093C151.38 59.0296 151.608 58.8012 151.608 58.5148V56.5153C151.621 56.2271 151.392 55.9987 151.107 55.9987Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M150.507 53.0719H146.761C146.474 53.0719 146.246 53.3003 146.246 53.5867C146.246 53.8732 146.474 54.1016 146.761 54.1016H150.507C150.793 54.1016 151.022 53.8732 151.022 53.5867C151.02 53.3003 150.792 53.0719 150.507 53.0719Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M150.935 46.901C150.649 46.901 150.42 47.1294 150.42 47.4159V48.9023H148.733C148.446 48.9023 148.218 49.1307 148.218 49.4171V51.4891C148.218 51.7755 148.446 52.0039 148.733 52.0039C149.02 52.0039 149.248 51.7755 149.248 51.4891V49.9319H150.935C151.222 49.9319 151.45 49.7035 151.45 49.4171V47.4177C151.45 47.1294 151.222 46.901 150.935 46.901Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M152.637 51.1997C152.35 51.1997 152.122 51.4281 152.122 51.7145V55.4578C152.122 55.7443 152.35 55.9727 152.637 55.9727C152.923 55.9727 153.152 55.7443 153.152 55.4578V51.7145C153.15 51.4281 152.907 51.1997 152.637 51.1997Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M143.488 47.9285H146.075V50.5135H143.488V47.9285ZM146.59 46.9007H142.973C142.687 46.9007 142.458 47.1291 142.458 47.4155V51.0301C142.458 51.3165 142.687 51.5449 142.973 51.5449H146.59C146.877 51.5449 147.106 51.3165 147.106 51.0301V47.4155C147.104 47.1291 146.875 46.9007 146.59 46.9007Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M143.488 57.485H146.075V60.07H143.488V57.485ZM146.59 56.4554H142.973C142.687 56.4554 142.458 56.6838 142.458 56.9702V60.5848C142.458 60.8712 142.687 61.0996 142.973 61.0996H146.59C146.877 61.0996 147.106 60.8712 147.106 60.5848V56.9702C147.104 56.6856 146.875 56.4554 146.59 56.4554Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M153.923 57.485H156.51V60.07H153.923V57.485ZM157.025 56.4554H153.408C153.121 56.4554 152.893 56.6838 152.893 56.9702V60.5848C152.893 60.8712 153.121 61.0996 153.408 61.0996H157.025C157.312 61.0996 157.54 60.8712 157.54 60.5848V56.9702C157.54 56.6856 157.31 56.4554 157.025 56.4554Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M154.966 46.9006H152.965C152.678 46.9006 152.45 47.129 152.45 47.4154C152.45 47.7018 152.678 47.9302 152.965 47.9302H154.452V49.616C154.452 49.9025 154.681 50.1309 154.968 50.1309H157.041C157.328 50.1309 157.556 49.9025 157.556 49.616C157.556 49.3296 157.328 49.1012 157.041 49.1012H155.483V47.4154C155.481 47.129 155.238 46.9006 154.966 46.9006Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M157.025 52.7282H155.267C154.981 52.7282 154.752 52.9566 154.752 53.243C154.752 53.5294 154.981 53.7578 155.267 53.7578H157.025C157.312 53.7578 157.54 53.5294 157.54 53.243C157.54 52.9566 157.31 52.7282 157.025 52.7282Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M140.515 56.0981C140.229 56.0981 140 56.3265 140 56.6129V63.4832C140 63.7696 140.229 63.998 140.515 63.998H147.39C147.677 63.998 147.906 63.7696 147.906 63.4832C147.906 63.1968 147.677 62.9684 147.39 62.9684H141.029V56.6129C141.029 56.3283 140.8 56.0981 140.515 56.0981Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M159.483 56.0983C159.196 56.0983 158.968 56.3267 158.968 56.6131V62.9704H152.606C152.319 62.9704 152.091 63.1988 152.091 63.4852C152.091 63.7716 152.319 64 152.606 64H159.481C159.768 64 159.996 63.7716 159.996 63.4852V56.6149C159.998 56.3285 159.77 56.0983 159.483 56.0983Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M159.483 44.0006H152.607C152.321 44.0006 152.092 44.229 152.092 44.5154C152.092 44.8018 152.321 45.0302 152.607 45.0302H158.969V51.3875C158.969 51.6739 159.198 51.9023 159.485 51.9023C159.771 51.9023 160 51.6739 160 51.3875V44.5172C159.998 44.229 159.769 44.0006 159.483 44.0006Z"
						fill="#7F7F7F"
					/>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M147.39 44.0005H140.515C140.229 44.0005 140 44.2289 140 44.5153V51.3856C140 51.672 140.229 51.9004 140.515 51.9004C140.802 51.9004 141.03 51.672 141.03 51.3856V45.0301H147.392C147.679 45.0301 147.907 44.8017 147.907 44.5153C147.906 44.2289 147.675 44.0005 147.39 44.0005Z"
						fill="#7F7F7F"
					/>
				</g>
				<path opacity={0.2} d="M160 32H102V36H160V32Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M134 44H102V46H134V44Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M126 50H102V52H126V50Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M126 56H102V58H126V56Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M145 86H102V88H145V86Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M130 62H102V64H130V62Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M126 92H118V94H126V92Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M110 98H102V100H110V98Z" fill="#7F7F7F" />
				<path d="M123 107H106V109H123V107Z" fill="#7F7F7F" />
				<path d="M186 107H173V109H186V107Z" fill="#7F7F7F" />
				<path d="M118 156H106V158H118V156Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M160 92H136V94H160V92Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M160 98H136V100H160V98Z" fill="#7F7F7F" />
				<path opacity={0.1} d="M226.5 74.5V99.5H169.5V74.5H226.5Z" stroke="black" />
				<path opacity={0.2} d="M179 79H173V81H179V79Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M179 86H173V88H179V86Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M199 86H193V88H199V86Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M199 94H193V96H199V94Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M217 94H211V96H217V94Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M217 86H211V88H217V86Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M179 93H173V95H179V93Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M199 79H193V81H199V79Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M217 79H211V81H217V79Z" fill="#7F7F7F" />
				<path opacity={0.1} d="M226.5 107.5V182.5H169.5V107.5H226.5Z" stroke="black" />
				<path opacity={0.2} d="M179 32H169V36H179V32Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M179 44H169V46H179V44Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M186 50H169V52H186V50Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M186 56H169V58H186V56Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M221 44H211V46H221V44Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M227 49H217V51H227V49Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M204 49H194V51H204V49Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M227 62H211V64H227V62Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M227 68H214V70H227V68Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M182 68H169V70H182V68Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M121 72H102V74H121V72Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M134 77H102V79H134V77Z" fill="#7F7F7F" />
				<path opacity={0.2} d="M150 72H139V74H150V72Z" fill="#7F7F7F" />
				<path d="M225 17H208V22H225V17Z" fill="white" fillOpacity={0.6} />
				<path d="M149 15H102V18H149V15Z" fill="white" fillOpacity={0.6} />
				<path d="M135 20H102V23H135V20Z" fill="white" fillOpacity={0.6} />
			</g>
			<defs>
				<filter
					id="filter0_d_7482_32142"
					x={94}
					y={11}
					width={141}
					height={182}
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy={4} />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7482_32142" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_7482_32142"
						result="shape"
					/>
				</filter>
				<clipPath id="clip0_7482_32142">
					<rect width={328} height={200} fill="white" />
				</clipPath>
				<clipPath id="clip1_7482_32142">
					<rect width={20} height={20} fill="white" transform="matrix(1 0 0 -1 140 64)" />
				</clipPath>
			</defs>
		</svg>
	);
}
export const MemoPlaceholderRegistrationDocumentRear = React.memo(
	PlaceholderRegistrationDocumentRear
);
